import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";

export default function AuthPage({ mode }) {
  const isLogin = mode === "login";
  const { signIn } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const body = isLogin ? { email: form.email, password: form.password } : form;
      const { data } = await api.post(`/auth/${isLogin ? "login" : "register"}`, body);
      signIn(data);
      toast.success(isLogin ? "Welcome back" : "Account created");
      nav("/history");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 pt-20" data-testid={`${mode}-page`}>
      <p className="eyebrow mb-4">{isLogin ? "Sign in" : "Create account"}</p>
      <h1 className="font-serif-d text-5xl tracking-tight mb-10">{isLogin ? "Welcome back." : "Keep every review."}</h1>
      <form onSubmit={submit} className="space-y-5">
        {!isLogin && (
          <label className="block"><span className="eyebrow">Name</span>
            <Input required value={form.name} onChange={set("name")} className="mt-2 rounded-none bg-[var(--card)] h-12" data-testid="auth-name-input" /></label>
        )}
        <label className="block"><span className="eyebrow">Email</span>
          <Input required type="email" value={form.email} onChange={set("email")} className="mt-2 rounded-none bg-[var(--card)] h-12" data-testid="auth-email-input" /></label>
        <label className="block"><span className="eyebrow">Password</span>
          <Input required type="password" minLength={6} value={form.password} onChange={set("password")} className="mt-2 rounded-none bg-[var(--card)] h-12" data-testid="auth-password-input" /></label>
        {error && <p className="text-sm text-[var(--red)]" data-testid="auth-error">{error}</p>}
        <button disabled={busy} className="btn-ink w-full h-12 text-sm font-medium disabled:opacity-50" data-testid="auth-submit-btn">
          {busy ? "Please wait..." : isLogin ? "Sign in" : "Create account"}
        </button>
      </form>
      <p className="text-sm text-[var(--ink-2)] mt-8">
        {isLogin ? "New here? " : "Already have an account? "}
        <Link to={isLogin ? "/register" : "/login"} className="underline underline-offset-4" data-testid="auth-switch-link">
          {isLogin ? "Create an account" : "Sign in"}
        </Link>
      </p>
    </div>
  );
}
